import { RelodeApiError, SuccessAction } from "@relode/core";
import {
    ActionsUnion,
    createAction,
    createMetaAction,
} from "@relode/core/components/reducer/actionHelpers";
import { TeamResponse } from "../../../shared/backend/controllers/teams";
import { JobManagerContact, TagMatch } from "../../../shared/types";

enum names {
    // Add Job
    ADD_NEW_JOB = "ADD_NEW_JOB",
    ADD_NEW_JOB_SUCCESS = "ADD_NEW_JOB_SUCCESS",
    ADD_NEW_JOB_FAILURE = "ADD_NEW_JOB_FAILURE",
    // Step 1
    LOAD_ADD_JOB_STEP_1 = "LOAD_ADD_JOB_STEP_1",
    LOAD_ADD_JOB_STEP_1_SUCCESS = "LOAD_ADD_JOB_STEP_1_SUCCESS",
    LOAD_ADD_JOB_STEP_1_FAILURE = "LOAD_ADD_JOB_STEP_1_FAILURE",
    SAVE_ADD_JOB_STEP_1 = "SAVE_ADD_JOB_STEP_1",
    SAVE_ADD_JOB_STEP_1_SUCCESS = "SAVE_ADD_JOB_STEP_1_SUCCESS",
    SAVE_ADD_JOB_STEP_1_FAILURE = "SAVE_ADD_JOB_STEP_1_FAILURE",
    // Step 2
    LOAD_ADD_JOB_STEP_2 = "LOAD_ADD_JOB_STEP_2",
    LOAD_ADD_JOB_STEP_2_SUCCESS = "LOAD_ADD_JOB_STEP_2_SUCCESS",
    LOAD_ADD_JOB_STEP_2_FAILURE = "LOAD_ADD_JOB_STEP_2_FAILURE",
    SAVE_ADD_JOB_STEP_2 = "SAVE_ADD_JOB_STEP_2",
    SAVE_ADD_JOB_STEP_2_SUCCESS = "SAVE_ADD_JOB_STEP_2_SUCCESS",
    SAVE_ADD_JOB_STEP_2_FAILURE = "SAVE_ADD_JOB_STEP_2_FAILURE",

    ATTACHMENT_UPLOAD_STARTED = "ATTACHMENT_UPLOAD_STARTED",
    ATTACHMENT_UPLOAD_SUCCESS = "ATTACHMENT_UPLOAD_SUCCESS",
    ATTACHMENT_UPLOAD_FAILURE = "ATTACHMENT_UPLOAD_FAILURE",

    // Step 3
    LOAD_ADD_JOB_STEP_3 = "LOAD_ADD_JOB_STEP_3",
    LOAD_ADD_JOB_STEP_3_SUCCESS = "LOAD_ADD_JOB_STEP_3_SUCCESS",
    LOAD_ADD_JOB_STEP_3_FAILURE = "LOAD_ADD_JOB_STEP_3_FAILURE",

    MOVE_JOB_TO_REQUESTED = "MOVE_JOB_TO_REQUESTED",
    MOVE_JOB_TO_REQUESTED_SUCCESS = "MOVE_JOB_TO_REQUESTED_SUCCESS",
    MOVE_JOB_TO_REQUESTED_FAILURE = "MOVE_JOB_TO_REQUESTED_FAILURE",

    // Copy Job
    COPY_JOB = "COPY_JOB",
    COPY_JOB_SUCCESS = "COPY_JOB_SUCCESS",
    COPY_JOB_FAILURE = "COPY_JOB_FAILURE",

    //Navigation
    HANDLE_NEXT_STEP = "HANDLE_NEXT_STEP",
    HANDLE_PREVIOUS_STEP = "HANDLE_PREVIOUS_STEP",

    // UI
    CLEAR_ERROR = "CLEAR_ERROR",
    EXIT = "EXIT",
}

export default names;

export const creators = {
    // Add Job
    addNewJob: () => createAction(names.ADD_NEW_JOB),
    addNewJobSuccess: (message: string) =>
        createMetaAction(
            names.ADD_NEW_JOB_SUCCESS,
            new SuccessAction(message),
            { message }
        ),
    addNewJobFailure: (apiError: RelodeApiError) =>
        createAction(names.ADD_NEW_JOB_FAILURE, { apiError }),

    //Step 1
    loadAddJobStep1: () => createAction(names.LOAD_ADD_JOB_STEP_1),
    loadAddJobStep1Success: (
        teams: TeamResponse[],
        jobId: number,
        showOrderDetails: boolean
    ) =>
        createAction(names.LOAD_ADD_JOB_STEP_1_SUCCESS, {
            teams,
            jobId,
            showOrderDetails,
        }),
    loadAddJobStep1Failure: (apiError: RelodeApiError) =>
        createAction(names.LOAD_ADD_JOB_STEP_1_FAILURE, { apiError }),
    saveAddJobStep1: () => createAction(names.SAVE_ADD_JOB_STEP_1),
    saveAddJobStep1Success: (
        jobId: number,
        showOrderDetails: boolean,
        message: string,
        showSnack: boolean
    ) =>
        createMetaAction(
            names.SAVE_ADD_JOB_STEP_1_SUCCESS,
            showSnack ? new SuccessAction(message) : null,
            { jobId, showOrderDetails }
        ),
    saveAddJobStep1Failure: (apiError: RelodeApiError) =>
        createAction(names.SAVE_ADD_JOB_STEP_1_FAILURE, { apiError }),

    //Step2
    loadAddJobStep2: () => createAction(names.LOAD_ADD_JOB_STEP_2),
    loadAddJobStep2Success: () =>
        createAction(names.LOAD_ADD_JOB_STEP_2_SUCCESS),
    loadAddJobStep2Failure: (apiError: RelodeApiError) =>
        createAction(names.LOAD_ADD_JOB_STEP_2_FAILURE, { apiError }),
    saveAddJobStep2: () => createAction(names.SAVE_ADD_JOB_STEP_2),
    saveAddJobStep2Success: (message: string, showSnack: boolean) =>
        createMetaAction(
            names.SAVE_ADD_JOB_STEP_2_SUCCESS,
            showSnack ? new SuccessAction(message) : null
        ),
    saveAddJobStep2Failure: (apiError: RelodeApiError) =>
        createAction(names.SAVE_ADD_JOB_STEP_2_FAILURE, { apiError }),

    attachmentStartUpload: () => createAction(names.ATTACHMENT_UPLOAD_STARTED),
    attachmentUploadSucceeded: () =>
        createAction(names.ATTACHMENT_UPLOAD_SUCCESS),
    attachmentUploadFailed: (message?: string, apiError?: RelodeApiError) =>
        createAction(names.ATTACHMENT_UPLOAD_FAILURE, {
            message,
            apiError,
        }),

    // Step 3
    loadAddJobStep3: () => createAction(names.LOAD_ADD_JOB_STEP_3),
    loadAddJobStep3Success: () =>
        createAction(names.LOAD_ADD_JOB_STEP_3_SUCCESS),
    loadAddJobStep3Failure: (apiError: RelodeApiError) =>
        createAction(names.LOAD_ADD_JOB_STEP_3_FAILURE, { apiError }),

    moveJobToRequested: () => createAction(names.MOVE_JOB_TO_REQUESTED),
    moveJobToRequestedSuccess: (
        message: string,
        jobManager: JobManagerContact
    ) =>
        createMetaAction(
            names.MOVE_JOB_TO_REQUESTED_SUCCESS,
            new SuccessAction(message),
            { jobManager }
        ),
    moveJobToRequestedFailure: (apiError: RelodeApiError) =>
        createAction(names.MOVE_JOB_TO_REQUESTED_FAILURE, { apiError }),

    // Copy Job
    copyJob: () => createAction(names.COPY_JOB),
    copyJobSuccess: (jobId: number) =>
        createAction(names.COPY_JOB_SUCCESS, { jobId }),
    copyJobFailure: (apiError: RelodeApiError) =>
        createAction(names.COPY_JOB_FAILURE, { apiError }),

    //Navigation
    handleNextStep: () => createAction(names.HANDLE_NEXT_STEP),
    handlePreviousStep: () => createAction(names.HANDLE_PREVIOUS_STEP),

    // UI
    clearError: () => createAction(names.CLEAR_ERROR),
    exit: (jobId: number) => createAction(names.EXIT, { jobId }),
};

export type AddJobActionTypes = ActionsUnion<typeof creators>;
